const rankings = [
  { rank: 1, title: '恋爱幻想曲', tag: '韩漫·恋爱', hot: '🔥 98.6万', change: 'up' },
  { rank: 2, title: '魔导纪元', tag: '日漫·奇幻', hot: '🔥 95.2万', change: 'up' },
  { rank: 3, title: '仙途无尽', tag: '国漫·仙侠', hot: '🔥 91.8万', change: 'same' },
  { rank: 4, title: '书灵奇缘', tag: '日漫·奇幻', hot: '🔥 87.3万', change: 'up' },
  { rank: 5, title: '暗夜追踪者', tag: '国漫·悬疑', hot: '🔥 82.5万', change: 'down' },
  { rank: 6, title: '宫廷秘史', tag: '韩漫·古风', hot: '🔥 78.9万', change: 'up' },
];

const changeIcon = (c: string) => {
  if (c === 'up') return <i className="ri-arrow-up-line text-accent-600 text-sm"></i>;
  if (c === 'down') return <i className="ri-arrow-down-line text-primary-500 text-sm"></i>;
  return <i className="ri-subtract-line text-foreground-400 text-sm"></i>;
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">人气排行</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">妖精漫画网读者最爱的热门漫画排行，数据实时更新</p>
        </div>
        <div className="max-w-2xl mx-auto bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 px-5 py-4 border-b border-background-100 last:border-0 hover:bg-background-100/50 transition-colors cursor-pointer"
            >
              <div className={`w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg font-bold text-sm ${
                item.rank <= 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="w-9 h-9 flex items-center justify-center">{changeIcon(item.change)}</div>
              <div className="flex-1 min-w-0">
                <div className="font-heading text-sm text-foreground-900 truncate">{item.title}</div>
                <div className="text-xs text-foreground-500">{item.tag}</div>
              </div>
              <div className="text-xs text-primary-600 font-medium whitespace-nowrap">{item.hot}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}